"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRegisterInstitution = exports.apiSetInstitution = exports.apiSetTeacherMeta = exports.apiResetPassword = exports.apiVerifyPasswordReset = exports.apiRequestPasswordReset = exports.apiActivateTeacher = exports.apiVerifyTeacherActivation = exports.apiCreateTeacher = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
/**
 * Create a activation request for a teacher.
 * @param email the email of the teacher.
 * @param loginName the loginName of the teacher.
 */
const apiCreateTeacher = async (email, loginName, accountType = 'trial', institutionCode = '') => {
    try {
        await client_1.default.post('/teachers/sign-up', {
            email,
            loginName,
            accountType,
            institutionCode,
        });
    }
    catch (error) {
        throw (0, util_1.handleError)(error);
    }
};
exports.apiCreateTeacher = apiCreateTeacher;
/**
 * Verify that the token from the activation exists and hasn't expired.
 * @param token the token verify
 */
const apiVerifyTeacherActivation = async (token) => {
    try {
        await client_1.default.get(`/teachers/verify-sign-up/${token}`);
    }
    catch (error) {
        throw (0, util_1.handleError)(error);
    }
};
exports.apiVerifyTeacherActivation = apiVerifyTeacherActivation;
/**
 * Create the teachers account.
 * @param token the token from the activation
 * @param password the password of the new teacher
 * @returns the newly created teacher
 */
const apiActivateTeacher = async (token, password) => {
    try {
        const { data } = await client_1.default.post('/teachers/activate', {
            token,
            password,
        });
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiActivateTeacher = apiActivateTeacher;
/**
 * Request a password reset for a teacher with the given email.
 * @param email
 */
const apiRequestPasswordReset = async (email) => {
    try {
        await client_1.default.post('/teachers/request-password-reset', { email });
    }
    catch (error) {
        throw (0, util_1.handleError)(error);
    }
};
exports.apiRequestPasswordReset = apiRequestPasswordReset;
/**
 * Verify that the password reset token is valid.
 * @param token
 */
const apiVerifyPasswordReset = async (token) => {
    try {
        await client_1.default.get(`/teachers/verify-password-reset/${token}`);
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiVerifyPasswordReset = apiVerifyPasswordReset;
/**
 * Update a teachers password.
 * @param token
 * @param newPassword
 * @returns The updated teacher.
 */
const apiResetPassword = async (token, newPassword) => {
    try {
        const { data } = await client_1.default.post('/teachers/reset-password', {
            token,
            newPassword,
        });
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiResetPassword = apiResetPassword;
const apiSetTeacherMeta = async (meta) => {
    const { data } = await client_1.default.put('/teachers/set-meta', Object.assign({}, meta));
    return data;
};
exports.apiSetTeacherMeta = apiSetTeacherMeta;
/**
 * Update a teachers institution.
 * @returns The updated teacher.
 */
const apiSetInstitution = async (newData) => {
    try {
        const { data } = await client_1.default.post('/teachers/set-institution', newData);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiSetInstitution = apiSetInstitution;
/**
 * Register a new institution.
 * @returns The new institution.
 */
const apiRegisterInstitution = async (newData) => {
    try {
        const { data } = await client_1.default.post('/teachers/register-institution', newData);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiRegisterInstitution = apiRegisterInstitution;
//# sourceMappingURL=teachers.js.map